import styled from 'styled-components/macro';

export const SearchBarContainer = styled.div`
  position: relative;
  width: 30%;
`;

export const SearchIcon = styled.img`
  position: absolute;
  left: 10px;
  top: 14px;
  height: 18px;
  width: 18px;
  :hover {
    cursor: pointer;
  }
`;

export const TooltipButtonContainer = styled.div`
position: absolute;
  left: -35px;
  top: 12px;
  height: 18px;
  width: 18px;
  :hover {
    cursor: pointer;
  }
`;

export const ClearIcon = styled.img`
position: absolute;
  right: 10px;
  top: -1px;
  height: 50px;
  width: 50px;
  :hover {
    cursor: pointer;
  }
`;

export const SearchBar = styled.input`
  font-size: ${(props) => props.theme.typography.sizes.small};
  padding-left: 50px;
  border: 0.5px solid #263238;
  border-radius: 12px; 
  height: 46px;
  width: 100%;

  ::placeholder {
    color: ${(props) => props.theme.palette.gray[75]};
  }
  
  :focus {
    outline: none;
  }
`;
